export default __webpack_public_path__ + "cc01b8c736b4a31aa0dcd5f0dc84cc13.png";